import styled from 'styled-components';
import { ConsolePanel } from '@/ui';
import type { Community } from '@/core/models/community';

const Panel = styled(ConsolePanel)`margin-top: 14px;`;
const H = styled.h3`margin: 0 0 12px; font-family: ${({ theme }) => theme.font.display}; font-size: ${({ theme }) => theme.fontSize.md}; color: ${({ theme }) => theme.color.textPrimary};`;
const List = styled.ol`margin: 0; padding-left: 18px; display: flex; flex-direction: column; gap: 8px;`;
const Item = styled.li`font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;

export function RulesTab({ community }: { community: Community }) {
  return (
    <Panel>
      <H>Community Rules</H>
      <List>{community.rules.map((r) => <Item key={r}>{r}</Item>)}</List>
    </Panel>
  );
}
